{
  "version": 1,
  "asset_id": "45f10a92-cfda-4e14-a149-da20250d8094",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/45f10a92-cfda-4e14-a149-da20250d8094/hardware-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/45f10a92-cfda-4e14-a149-da20250d8094/hardware-card.webp",
  "original_filename": "hardware-card.webp",
  "size": 47492,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:30Z"
}
